<div class="container-fluid p-2">

    <div class="pb-0 d-flex flex-wrap">

      <div class="pb-3 d-flex flex-row" *ngIf="scoutTask">
        <app-scout-header [scoutTaskDoc]="scoutTask"></app-scout-header>
        <div class="btn-group px-1 pb-sm-3 my-auto text-nowrap" *ngIf="roleMgr.canEditTasks" dropdown>
            <a id="edit-options-btn" href="javascript:false;" behavior="button" dropdownToggle class="dropdown-toggle" aria-controls="dropdown-edit-options">
                <span class="caret"></span>
            </a>
            <ul style="z-index:9999;min-width:3rem;" id="dropdown-edit-options" *dropdownMenu class="p-1 dropdown-menu"
                role="menu" aria-labelledby="edit-options-btn">
                <li role="menuitem" style="margin-bottom:2px;">
                    <button class="btn btn-primary w-100 text-left" style="border-radius:0;"
                            [disabled]="!roleMgr.canEditPointTests" (click)="onReportData([],$event)">
                        <i class="fa fa-database mr-1"></i>
                        Report Data
                    </button>
                </li>
                <li role="menuitem" style="margin-bottom:2px;">
                    <button class="btn btn-secondary w-100 text-left" style="border-radius:0;"
                            [disabled]="!(roleMgr.canEditPointTests||roleMgr.canAssignScheduler||roleMgr.canSchedule)" (click)="onEdit($event)">
                        <i class="fa fa-edit mr-1"></i>
                        Edit
                    </button>
                </li>
                <li role="menuitem" style="margin-bottom:0;">
                    <button class="btn btn-secondary w-100 text-left" style="border-radius:0;"
                            (click)="onShowKml(scoutPaths,$event)">
                        <i class="fa fa-globe-americas mr-1"></i>
                        KML
                    </button>
                </li>
            </ul>
        </div>
      </div>
    </div>

    <div *fesListView="let filteredScoutPaths of scoutPaths;"
            class="pb-2 busy-overlay-parent" [ngClass]="bProcessing?'disabled':''">

        <div *ngIf="bProcessing" class="font-weight-bold busy-overlay">
            <i class="fa fa-spinner fa-spin"></i>&nbsp;Processing...
        </div>

        <table class="path-list-table table table-striped table-bordered table-sm">
            <thead>
                <tr>
                    <th fesSortField="pathNumber" [sortType]="'numeric'">Path #</th>
                    <th fesSortField="floor" [sortType]="'numeric'">Floor</th>
                    <th fesSortField="haPoint.pointId">HA Point</th>
                    <th>Scout Points
                        <div class="small text-nowrap" style="font-size:10px;">
                            <label>
                            <input name="bShowPhotoSummary" type="checkbox" [(ngModel)]="bShowPhotoSummary">
                            Photo Links
                            </label>
                        </div>
                    </th>
                    <th>Description</th>
                    <th fesSortField="modifiedDate">Modified (Local)</th>
                    <th fesSortField="statusName">Status</th>
                    <th style="border-left:none;text-align: center;">
                        <button (click)="onAddPath()" class="btn btn-secondary add-btn">
                            <i class="fa fa-plus-square"></i> Add
                        </button>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let scoutPath of filteredScoutPaths;">
                    <td class="text-center align-middle">{{scoutPath.pathNumber|number:'2.0'}}</td>
                    <td class="text-center align-middle">{{scoutPath.floor}}</td>
                    <td class="text-center align-middle">
                        <ng-container *ngIf="scoutPath.haPoint">
                            <a *ngIf="scoutPath.haPoint.pointId; else newHaPointName"
                                class="text-nowrap font-smaller" href="javascript:false;"
                                (click)="onShowPoint(scoutPath.haPoint.pointId)">
                                {{scoutPath.haPoint.pointId}}
                            </a>
                            <ng-template #newHaPointName>{{scoutPath.haPoint.exPointId}}</ng-template>
                        </ng-container>
                    </td>
                    <td style="min-width:12.5em;" >
                        <div class="d-flex flex-wrap" [ngClass]="bShowPhotoSummary?'justify-content-start':'justify-content-center'">
                        <ng-container *ngFor="let pt of scoutPath.scoutPoints">
                            <app-scout-point-photo-links
                                class="mb-1"
                                [ngClass]="selectedPointId==pt?.id && 'selected-scout-point'"
                                [uiLocked]="scoutPath.uiLocked"
                                [scoutPoint]="pt"
                                [bShowPhotoSummary]="bShowPhotoSummary"
                                [scoutTask]="scoutTask"
                                [scoutPath]="scoutPath"
                                (scoutPointIdSelected)="this.selectedPointId=$event"
                            ></app-scout-point-photo-links>
                        </ng-container>
                        </div>
                    </td>
                    <td class="w-50">{{scoutPath.description}}</td>
                    <td class="text-nowrap align-middle">
                        {{scoutPath.modifiedDate|date:'yyyy-MM-dd HH:mm:ss'}}
                        <div class="small text-muted font-italic">
                            {{scoutPath.userName}}
                        </div>
                    </td>
                    <!-- <td class="text-center align-middle">{{scoutPath.status}}</td> -->
                    <ng-container [ngSwitch]="scoutPath.statusName">
                        <td *ngSwitchCase="'complete'" class="text-center align-middle status-complete">Approved</td>
                        <td *ngSwitchCase="'in progress'" class="text-center align-middle status-in-progress">In Progress</td>
                        <td *ngSwitchCase="'not started'" class="text-center align-middle status-not-started">Not Started</td>
                        <td *ngSwitchCase="'field complete'" class="text-center align-middle status-field-complete">Field Complete</td>
                        <td *ngSwitchCase="'review complete'" class="text-center align-middle status-review-complete">Review Complete</td>
                        <td *ngSwitchCase="'not using'" class="text-center align-middle status-not-using">Not Using</td>
                        <td *ngSwitchDefault class="text-center align-middle">{{scoutPath.statusName}}</td>
                      </ng-container>
                    <td class="text-center align-middle">
                        <a class="text-nowrap font-smaller" href="javascript:false;"
                            (click)="onEditScoutPath(scoutPath)">edit</a>
                        <div class="btn-group p-0 m-0" dropdown>
                            <a id="edit-options-btn" href="javascript:false;" behavior="button" dropdownToggle class="dropdown-toggle" aria-controls="dropdown-edit-options">
                                <span class="caret"></span>
                            </a>
                            <ul style="z-index:9999;min-width:3rem;" id="dropdown-edit-options" *dropdownMenu
                                class="text-nowrap p-2 dropdown-menu dropdown-menu-right" role="menu" aria-labelledby="edit-options-btn">
                                <li role="menuitem" style="margin-bottom:2px;">
                                    <button class="btn btn-primary w-100 text-left" style="border-radius:0;"
                                            (click)="onReportDoc(scoutPath,$event)">
                                        <i class="fa fa-file-word mr-1"></i>
                                        Report Builder (MS Word)
                                    </button>
                                </li>
                                <li role="menuitem" style="margin-bottom:2px;">
                                    <button class="btn btn-primary w-100 text-left" style="border-radius:0;"
                                            (click)="onReportData([scoutPath],$event)">
                                        <i class="fa fa-database mr-1"></i>
                                        Report Data
                                    </button>
                                </li>
                                <li role="menuitem">
                                    <button class="btn btn-secondary w-100 text-left" style="border-radius:0;"
                                            (click)="onShowKml([scoutPath],$event)">
                                        <i class="fa fa-globe mr-1"></i>
                                        KML
                                    </button>
                                </li>
                                <ng-container *ngIf="canDeleteByStatusId[scoutPath.statusId]&&userIsAdminOrPm">
                                <li class="divider dropdown-divider"></li>
                                <li role="menuitem">
                                    <button [disabled]="bProcessing" class="btn btn-warning w-100 text-left" style="border-radius:0;"
                                        (click)="onDeleteScoutPath(scoutPath)">
                                        <i class="fa fa-times-circle text-danger mr-1"></i>
                                        Delete Scout Path #{{scoutPath.pathNumber|number:'2.0'}}
                                    </button>
                                </li>
                                </ng-container>
                            </ul>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <div *ngIf="scoutTask.schedule.scheduleNotes" class="row p-3">
            <span class="gray font-italic pl-2">Access Procedures/Notes</span>
              <div id='access-notes'>{{scoutTask.schedule.scheduleNotes}}</div>
        </div>
    </div>
</div>

